export const FILTER_TYPE_TEXT = 'TEXT';
export const FILTER_TYPE_SELECT = 'SELECT';
export const FILTER_TYPE_CHECKBOX = 'CHECKBOX';
export const FILTER_TYPE_DATE = 'DATE';
export const FILTER_TYPE_DATE_RANGE = 'DATE_RANGE';
export const FILTER_TYPE_HIDDEN = 'HIDDEN';
